/* unplugin-vue-components disabled */import { render } from "./PlayerWrapper.vue?vue&type=template&id=7247da46&scoped=true"
import script from "./PlayerWrapper.vue?vue&type=script&lang=js"
export * from "./PlayerWrapper.vue?vue&type=script&lang=js"

import "./PlayerWrapper.vue?vue&type=style&index=0&id=7247da46&lang=css"
import "./PlayerWrapper.vue?vue&type=style&index=1&id=7247da46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7247da46"]])

export default __exports__